import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { Alert } from '../functions'

const { __, sprintf } = wp.i18n
const object = vnObject

let trainingList = []
let training = {}

$(document).ready(() => {
  const trainingLimitOnRegistration = parseInt(object.training_limit_on_registration) ?? 7
  const trainingRegisterForm = $('.js-training-form')
  const columnsTrainingList = trainingRegisterForm.find('.trainings-list .columns')
  const rowsTrainingList = trainingRegisterForm.find('.trainings-list .rows')
  const jsSelectTrainingYear = trainingRegisterForm.find('#training_year')
  const jsTrainingCenterSelect = trainingRegisterForm.find(
    '.js-training-center-select',
  )
  const jsTrainingSelect = trainingRegisterForm.find('.js-training-select')
  const jsAddTrainingBtn = trainingRegisterForm.find('.js-training-add-btn')

  if (jsTrainingCenterSelect.val()) {
    const trainingCenterId = parseInt(jsTrainingCenterSelect.val())
    training.center = { id: trainingCenterId, name: jsTrainingCenterSelect.find(':selected').text() }
    training.training = null
    training.year = null
    const trainingsByCenterId = Object.values(object.training_datas).filter(
      (training) => training.centers_id.includes(trainingCenterId) || training.locations_id.includes(trainingCenterId),
    )

    let options =
      '<option value="">' + __('Choose a training', 'vn') + '</option>'
    trainingsByCenterId.forEach((e) => {
      options += '<option value="' + e.id + '">' + e.post_title + '</option>'
    })

    jsTrainingSelect.html(options)
  }

  const removeTrainingInList = (id) => {
    trainingList = getTrainingList()
    trainingList = trainingList.filter((e) => (e.training.id + '-' + e.center.id !== id))
    setTrainingList(trainingList)
  }

  const setTrainingList = (trainingList) => {
    trainingRegisterForm.attr('data-training-list', JSON.stringify(trainingList))
  }
  setTrainingList(trainingList)
  const getTrainingList = () => {
    let lsTrainingList = trainingRegisterForm.attr('data-training-list')
    return lsTrainingList !== null ? JSON.parse(lsTrainingList) : []
  }
  const resetTrainingFields = () => {
    jsTrainingCenterSelect.val('')
    training.center = null
    jsTrainingSelect.val('')
    training.training = null
    jsSelectTrainingYear.val('')
    training.years = null
  }
  const doList = () => {
    trainingList = getTrainingList()
    if (trainingList.length > 0) {
      jsAddTrainingBtn.addClass('active')
    } else {
      jsAddTrainingBtn.removeClass('active')
    }
    let output = ''
    if (trainingList.length > 0) {
      columnsTrainingList.css('display', 'grid')
      trainingList.forEach((e) => {
        const textPriority = e.is_priority ? __('Priority training', 'vn') : __('Set as priority', 'vn')
        const priorityClass = e.is_priority ? ' active' : ''
        output += '<div class="row">'
        output += '<div class="item priority-training js-set-priority-btn' + priorityClass + '" data-training-id="' + e.training.id + '-' + e.center.id + '">'
        output += '<span class="vn-a-icon"><i class="vn-icons-star-filled"></i></span>' + textPriority + '</div>'
        output += '<div class="item training_center">' + e.center.name + '</div>'
        output += '<div class="item training">' + e.training.post_title + '</div>'
        output += '<div class="item years">' + (e.years.length > 0 ? e.year.split('|')[0] : '') + '</div>'
        output += '<div class="item remove js-remove-training-btn" data-training-id="' + e.training.id + '-' + e.center.id + '"><span class="vn-a-icon"><i class="vn-icons-close"></i></span></div></div>'
      })
    } else {
      columnsTrainingList.css('display', 'none')
    }
    rowsTrainingList.html(output)

    const jsSetPriorityBtn = trainingRegisterForm.find('.js-set-priority-btn')
    jsSetPriorityBtn.on('click', (e) => {
      const elementId = e.currentTarget.getAttribute('data-training-id')
      trainingList.map((t) => {
        t.is_priority = (t.training.id + '-' + t.center.id === elementId)
      })
      setTrainingList(trainingList)
      doList()
    })

    const jsRemoveTrainingBtn = trainingRegisterForm.find('.js-remove-training-btn')
    jsRemoveTrainingBtn.on('click', (e) => {
      const elementId = e.currentTarget.getAttribute('data-training-id')
      removeTrainingInList(elementId)
      doList()
    })
  }

  jsTrainingCenterSelect.on('change', function() {
    const trainingCenterSelectElement = $(this)
    const trainingCenterId = parseInt(trainingCenterSelectElement.val())
    training.center = { id: trainingCenterId, name: trainingCenterSelectElement.find(':selected').text() }
    training.training = null
    training.year = null
    const trainingsByCenterId = Object.values(object.training_datas).filter(
      (training) => training.centers_id.includes(trainingCenterId) || training.locations_id.includes(trainingCenterId),
    )

    let options =
      '<option value="">' + __('Choose a training', 'vn') + '</option>'
    trainingsByCenterId.forEach((e) => {
      options += '<option value="' + e.id + '">' + e.post_title + '</option>'
    })

    jsTrainingSelect.html(options)

    let trainingYearOptions =
      '<option value="" selected>' +
      __('Choose a training year', 'vn') +
      '</option>'
    jsSelectTrainingYear.html(trainingYearOptions)

    trainingRegisterForm.find('.js-training-error-msg').hide()
    jsTrainingSelect.attr('disabled', false)
  })

  jsTrainingSelect.on('change', function(e) {
    training.year = null
    if (!training.center) {
      training.center = { id: jsTrainingCenterSelect.val(), name: jsTrainingCenterSelect.find(':selected').text() }
    }
    const trainingId = e.target.value
    let options =
      '<option value="" selected>' +
      __('Choose a training year', 'vn') +
      '</option>'
    if (!trainingId || trainingId.length === 0) {
      jsSelectTrainingYear.html(options)
      return
    }

    const trainingById = object.training_datas.find((t) => t.id === trainingId)
    training.training = trainingById
    training.years = trainingById.years

    if (trainingById.years) {
      trainingById.years.forEach((e) => {
        options +=
          '<option value="' +
          e.year +
          '|' +
          e.ypareo_year_code +
          '">' +
          e.year +
          '</option>'
      })
    } else {
      jsSelectTrainingYear.hide()
    }

    jsSelectTrainingYear.html(options)
    trainingRegisterForm.find('.js-training-error-msg').hide()
    jsTrainingSelect.attr('disabled', false)
  })

  jsSelectTrainingYear.on('change', function(e) {
    if (!training.training) {
      return
    }
    training.year = e.target.value

    if (trainingList.length === 0) {
      training.is_priority = false
      trainingList.push(training)
      setTrainingList(trainingList)
      resetTrainingFields()
      doList()
    }
  })

  jsAddTrainingBtn.on('click', () => {
    if (!training.center || !training.training) {
      Alert('error', __('Please fill in the fields to add a training', 'vn'), 2500)
      return
    }
    if (training.years.length > 0 && !training.year) {
      Alert('error', __('Please fill in the fields to add a training', 'vn'), 2500)
      return
    }
    if (trainingList.length >= trainingLimitOnRegistration) {
      Alert('error', sprintf(__('You have exceeded the limit of %s trainings in the list !', 'vn'), trainingLimitOnRegistration), 2500)
      return
    }

    if (!trainingList.find((t) => t.training.id === training.training.id && t.center.id === training.center.id)) {
      training.is_priority = false
      trainingList.push(training)
      setTrainingList(trainingList)
      resetTrainingFields()
    } else {
      Alert('error', __('Existing training!', 'vn'), 2500)
    }
    doList()
  })

  if (trainingRegisterForm.length) {
    trainingRegisterForm.parsley().on('form:success', function() {
      trainingRegisterForm.attr('data-success', 'true')
    })

    trainingRegisterForm.parsley().on('form:error', function() {
      trainingRegisterForm.attr('data-success', 'false')
    })

    trainingRegisterForm.on('submit', function(e) {
      e.preventDefault()
      e.stopPropagation()

      const $form = $(this)
      const formData = new FormData($form[0])
      trainingList = getTrainingList()

      if (trainingList.length === 0) {
        Alert('error', __('Please add training in the list', 'vn'))
        return
      }
      formData.append('action', 'vn_training_list_register')
      formData.append('training_list', JSON.stringify(trainingList))
      $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: formData,
        processData: false,
        contentType: false,
        beforeSend: () => {
          $form.addClass('sending')
          Alert('warning', object.formWait, false)
        },
        success: (res) => {
          $form.removeClass('sending')

          if (res.success) {
            // window.location = res.data.redirect
            const gcm = axeptioSDK?.userPreferencesManager?.choices?.$$googleConsentMode
            if (gcm?.analytics_storage === 'granted') {
              (trainingList || []).forEach(() => {
                window.dataLayer.push({ event: 'register_diploma_training_form' })
              })
            }
          }

          Alert(res.success, res.data.message)
        },
        error: (res) => {
          $form.removeClass('sending')

          if (res.success) {
            // window.location = res.data.redirect
          }

          Alert(res.error, res.data.message)
        },
      })
    })
  }
})
